import BUMPCoinIcon from '../../../assets/bump-coin.svg';
import BUSDCoinIcon from '../../../assets/busd-coin.svg';
import USDCCoinIcon from '../../../assets/usd-coin.svg';

export const CoinIcons: { [key: string]: string } = {
  USDC: USDCCoinIcon,
  bUSDC: BUSDCoinIcon,
  BUMP: BUMPCoinIcon,
};
